import { render, staticRenderFns } from "./AssociationSelect.vue?vue&type=template&id=08838830&scoped=true"
import script from "./AssociationSelect.vue?vue&type=script&lang=js"
export * from "./AssociationSelect.vue?vue&type=script&lang=js"
import style0 from "./AssociationSelect.vue?vue&type=style&index=0&id=08838830&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08838830",
  null
  
)

export default component.exports